import { Country, State } from "country-state-city";
import { generateRandomPassword } from "../common/commonFunctions";
import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const deleteLocation = async (ID, reason) => {
  try {
    let params = {
      data: [
        {
          id: ID,
          deleteReason: reason,
        },
      ],
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "locations/removeLocations",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const UpdateArea = async (areaId, organisation, isStore) => {
  try {
    let params = {
      areaId,
      organisation,
    };

    if (isStore) {
      params.isStore = false;
    }

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "location/checkArea",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
    return {
      status: err?.response?.status,
    };
  }
};

export const getParentBySubLoc = async (organisationID = "") => {
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + "location/find",
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const updateLocation = async (
  id,
  name,
  address,
  isParent,
  parentLocation,
  country,
  city,
  customer = [],
  vendors,
  teams,
  users,
  mainLocation,
  geofencingCoords,
  customFields,
  procedure = null,
  propertyType,
  area,
  image
) => {
  try {
    let params = {
      name,
      address,
      isParent,
      parentLocation,
      country,
      city,
      customers: customer,
      vendors,
      teams,
      users,
      mainLocation,
      geofencingCoords,
      customFields,
      procedure,
      propertyType,
      area,
      image,
    };

    if (customFields && customFields.length) {
      let newFieldsArray = customFields.map((one) => {
        if (one.new) {
          delete one.id;
        }
        return one;
      });
      params.customFields = newFieldsArray;
    }
    if (params.country) {
      params.countryName = Country.getCountryByCode(params.country).name;
    }
    if (params.city) {
      const citiesOfCountry = State.getStatesOfCountry(params.country);
      const the_city = params.city
        ? citiesOfCountry.filter((city) => {
            return city.isoCode == params.city;
          })[0].name
        : "";
      params.cityName = the_city;
    }

    if (area && area?.length) {
      let filteredArea = area.filter(
        (one) => one.attributes.name && one.attributes.name.trim()
      );
      params.area = filteredArea;
    }

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "locations/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const getLocationByID = async (the_ID, organisationID = "") => {
  const query = qs.stringify(
    {
      sort: ["countNumId:desc"],
      filters: {
        $and: [
          {
            organisation: {
              id: {
                $eq: organisationID,
              },
            },
          },
          {
            id: {
              $eq: the_ID,
            },
          },
        ],
      },
      populate: [
        "geofencingCoords",
        "customFields",
        "areas",
        "mainLocation",
        "users.userProfile.personalPicture",
        "createdByUser",
        "createdByUser.profileImage",
        "parentLocation",
        "teams",
        "customers.logo",
        "vendors",
        "vendors.logo",
        "image",
        "propertyType",

        "users.role",
        "users.profileImage",

        "procedure",
      ],
    },
    {
      encodeValuesOnly: true,
    }
  );
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `locations?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const createBulkLocation = async (data = [], organisationId = null) => {
  try {
    let params = {
      data,
      organisation: organisationId,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "location/import",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
    };
  }
};

export const createNewLocation = async (
  name,
  address,
  isParent,
  parentLocation,
  country,
  city,
  customer,
  vendors,
  teams,
  users,
  mainLocation,
  geofencingCoords,
  customFields,
  organisation = "",
  procedure = null,
  createdByUser = null,
  propertyType,
  area,
  image
) => {
  try {
    const password = generateRandomPassword(6);
    let params = {
      name,
      address,
      isParent,
      parentLocation,
      country,
      city,
      customers: customer,
      vendors,
      teams,
      users,
      mainLocation,
      geofencingCoords,
      customFields,
      organisation,
      procedure,
      createdByUser,
      propertyType,
      area,
      image,
    };

    if (params.country) {
      params.countryName = Country.getCountryByCode(params.country).name;
    }
    if (params.city) {
      const citiesOfCountry = State.getStatesOfCountry(params.country);
      const the_city = params.city
        ? citiesOfCountry.filter((city) => {
            return city.isoCode == params.city;
          })[0].name
        : "";
      params.cityName = the_city;
    }
    if (customFields && customFields.length) {
      let newFieldsArray = customFields.map((one) => {
        delete one.id;
        return one;
      });
      params.customFields = newFieldsArray;
    }

    if (area && area?.length) {
      let filteredArea = area.filter((one) => one.area && one.area.trim());
      params.area = filteredArea;
    }

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "locations",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};
